import React, { Component } from 'react';
import Header from '../layout/Partials/Header';
import * as Icon from 'react-feather';
import TextFieldGroup from '../common/TextFieldGroup';
import {
    getDecryptedSiteLicence,
    getSiteLicence,
    setSiteLicence,
} from '../../redux/actions/siteSettingsActions';
import TextAreaFieldGroup from '../common/TextAreaFieldGroup';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import Loading from '../common/Loading';
import { withStyles } from '@material-ui/styles';
import { Theme } from '../../utils/Theme';
import moment from 'moment';
import AdminLayout from '../layout/AdminLayout';
import { Divider, Button, Chip, Box } from '@material-ui/core';
import clsx from 'clsx';
import Section from '../UI/Section';
import { Helmet } from 'react-helmet';

const styles = Theme();

class SiteLicense extends Component {
    constructor(props) {
        super(props);
        this.state = {
            initialLoad: true,
            errors: {},
            decrypted: null,
            loading: true,
            owner: '',
            customer: '',
            control_key: '',
            licence_key: '',
        };

        this.onChange = this.onChange.bind(this);
        this.onSubmit = this.onSubmit.bind(this);
    }

    onChange = (e) => {
        this.setState({ [e.target.name]: e.target.value });
    };

    onSubmit = (e) => {
        e.preventDefault();
        const { owner, customer, control_key, licence_key } = this.state;

        this.props.setSiteLicence({
            owner,
            customer,
            control_key,
            licence_key,
        });
        this.setState({ initialLoad: true });
    };

    componentDidMount() {
        const { settings } = this.props;
        const { siteLicence, decrypted } = settings;

        if (!siteLicence) {
            this.props.getSiteLicence();
        }
        if (!decrypted) {
            this.props.getDecryptedSiteLicence();
        }
    }

    static getDerivedStateFromProps(nextProps, prevState) {
        let {
            errors,
            loading,
            decrypted,
            owner,
            customer,
            control_key,
            licence_key,
            initialLoad,
        } = prevState;

        if (nextProps.errors !== errors) {
            errors = nextProps.errors;
            loading = nextProps.loading;
        }

        if (!loading) {
            if (nextProps.settings.decrypted) {
                decrypted = nextProps.settings.decrypted;
            }

            if (nextProps.settings.siteLicence && initialLoad) {
                owner = nextProps.settings.siteLicence.owner;
                customer = nextProps.settings.siteLicence.customer;
                control_key = nextProps.settings.siteLicence.control;
                licence_key = nextProps.settings.siteLicence.key;
                initialLoad = false;
            }
        }

        return {
            initialLoad,
            errors,
            decrypted,
            owner,
            customer,
            control_key,
            licence_key,
            loading,
        };
    }

    render() {
        const {
            errors,
            loading,
            owner,
            customer,
            control_key,
            licence_key,
            decrypted,
        } = this.state;

        const { classes } = this.props;

        return (
            <AdminLayout hideSearchBar={true}>
                <Helmet>
                    <title>Site Licence</title>
                </Helmet>
                <div className="o-page">
                    <Header classes={classes} title={'Site Licence'} />
                    {!loading && (
                        <Box className="u-mh-xsmall">
                            <Section>
                                <Box
                                    className={clsx(
                                        'u-p-small u-m-small full_height'
                                    )}
                                >
                                    <div className="container">
                                        <div className="o-line">
                                            <div className="c-icon c-icon--large u-mb-small">
                                                <Icon.Key
                                                    className={
                                                        classes.colorInfo
                                                    }
                                                />
                                            </div>
                                            <h5 className={clsx('u-mb-xsmall')}>
                                                COUES Site Licence
                                            </h5>
                                        </div>

                                        {decrypted !== undefined &&
                                            decrypted !== null && (
                                                <div className={'o-line'}>
                                                    <p
                                                        className={`u-text-capitalize u-text-muted`}
                                                    >
                                                        <strong>
                                                            LICENCE TYPE{' '}
                                                        </strong>{' '}
                                                        :{' '}
                                                        {decrypted?.type.replace(
                                                            /'/g,
                                                            ' '
                                                        )}
                                                        <br />
                                                        <strong>
                                                            EXPIRY DATE{' '}
                                                        </strong>{' '}
                                                        :{' '}
                                                        {moment(
                                                            decrypted.exp_date
                                                        ).format('Do MMM YYYY')}
                                                        <br />
                                                    </p>

                                                    <Chip
                                                        label={
                                                            moment(
                                                                decrypted.exp_date
                                                            ) < moment()
                                                                ? 'In Active'
                                                                : 'Active'
                                                        }
                                                        className={
                                                            moment(
                                                                decrypted.exp_date
                                                            ) < moment()
                                                                ? clsx(
                                                                      classes.borderPrimary,
                                                                      classes.colorPrimary,

                                                                      classes.borderBold,
                                                                      'u-mt-small'
                                                                  )
                                                                : clsx(
                                                                      classes.borderSecondary,
                                                                      classes.backgroundLight,
                                                                      classes.colorSecondary,
                                                                      classes.borderBold,
                                                                      'u-mt-small'
                                                                  )
                                                        }
                                                    />
                                                </div>
                                            )}

                                        <Divider className="u-mt-small u-mb-medium" />

                                        <form
                                            noValidate
                                            onSubmit={this.onSubmit}
                                        >
                                            <TextFieldGroup
                                                error={errors.owner}
                                                value={owner || ''}
                                                label={'Owner name'}
                                                onChange={this.onChange}
                                                name={'owner'}
                                            />
                                            <TextFieldGroup
                                                error={errors.customer}
                                                value={customer || ''}
                                                label={'Owner organisation'}
                                                onChange={this.onChange}
                                                name={'customer'}
                                            />
                                            <TextAreaFieldGroup
                                                error={errors.licence_key}
                                                rows={7}
                                                value={licence_key || ''}
                                                label={'Licence Key'}
                                                onChange={this.onChange}
                                                name={'licence_key'}
                                            />
                                            <TextFieldGroup
                                                error={errors.control_key}
                                                value={control_key || ''}
                                                label={'Control number'}
                                                onChange={this.onChange}
                                                name={'control_key'}
                                            />
                                            <div className="o-line">
                                                <div className="">
                                                    <Button
                                                        type="submit"
                                                        className={`c-btn ${classes.buttonPrimary} has-arrow u-text-center`}
                                                    >
                                                        Save Details
                                                    </Button>
                                                </div>
                                                <div className="">
                                                    <Button
                                                        type="button"
                                                        onClick={(e) => {
                                                            this.props.history.goBack();
                                                        }}
                                                        className={`c-btn ${classes.buttonSecondary} has-arrow u-text-center`}
                                                    >
                                                        Cancel
                                                    </Button>
                                                </div>
                                            </div>
                                        </form>
                                    </div>
                                </Box>
                            </Section>
                        </Box>
                    )}
                    {loading && <Loading />}
                </div>
            </AdminLayout>
        );
    }
}

SiteLicense.propTypes = {
    auth: PropTypes.object.isRequired,
    errors: PropTypes.object.isRequired,
    getSiteLicence: PropTypes.func.isRequired,
    setSiteLicence: PropTypes.func.isRequired,
    getDecryptedSiteLicence: PropTypes.func.isRequired,
    classes: PropTypes.object,
    history: PropTypes.object,
    settings: PropTypes.object,
    loading: PropTypes.bool,
};

const mapStateToProps = (state) => ({
    auth: state.auth,
    errors: state.errors,
    settings: state.settings,
    loading: state.settings.loading,
});

export default connect(mapStateToProps, {
    setSiteLicence,
    getSiteLicence,
    getDecryptedSiteLicence,
})(withRouter(withStyles(styles)(SiteLicense)));
